import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const InvoicesListContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "orgDashboard/InvoicesListContainer" */
      './InvoicesListContainer'
    ),
});
